import React, { useEffect, useState } from "react";
import "./advertisements.css";
import { FaEdit, FaTimes   } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import Swal from "sweetalert2";
import axios from "axios";
import { useForm } from "react-hook-form";
import CreateQuillComponent from "../stations/createQuillComponent";
import ViewQuillComponent from "../textos/viewQuillComponent";

function Advertisements () {
  const [advertisement, setAdvertisement] = useState([]);
  const [createModal, setCreateModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [editQuillCreate, setEditQuillCreate] = useState(true);
  const [editQuillCreateEn, setEditQuillCreateEn] = useState(true);
  const [advertisementText, setAdvertisementText] = useState("{}");
  const [advertisementTextEn, setAdvertisementTextEn] = useState("{}");
  const [validBtn, setValidBtn] = useState(false);
  const [currentAdvertisement, setCurrentAdvertisement] = useState({
    "text_es": "",
    "text_en": "",
    "desc_es": "",
    "title_es": "",
    "desc_en": "",
    "id_advertisement": "",
    "title_en": "",
    "type": "banner"
  });
  const { handleSubmit, register, reset, setValue, formState: {errors, isValid} } = useForm();

  useEffect(() => {
    getAdvertisements();
  }, [updateTrigger]);

  useEffect(() => {
    if(!editQuillCreate && !editQuillCreateEn) {
      setValidBtn(true);
    } else {
      setValidBtn(false);
    }
  }, [editQuillCreate, editQuillCreateEn])

  React.useEffect(() => {
    Object.keys(currentAdvertisement).forEach(key => {
      setValue(key, currentAdvertisement[key]);
    });
  }, [currentAdvertisement, setValue]);

  const getAdvertisements = async () => {
    const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement`;
    try {
      const response = await axios.get(url, {
        headers: {
          authorization: process.env.REACT_APP_PUBLIC_KEY,
        }
      });

      const onlyAdvertisements = response.data.data.filter(
        item => item.type === "banner"
      );

      setAdvertisement(onlyAdvertisements);
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  }

  const statusModal = (status, id_code) => {
    if(status === "create") {
      setCreateModal(true);
      setEditQuillCreate(true);
      setEditQuillCreateEn(true);
      setAdvertisementText("{}");
      setAdvertisementTextEn("{}");
    } else if (status === 'update') {
      setUpdateModal(true);
      setEditQuillCreate(false);
      setEditQuillCreateEn(false);
    } else {
      setCreateModal(false);
      setUpdateModal(false);
      reset();
    }
  }

  const setterCurrentAdvertisement = (data) => {
    setCurrentAdvertisement({
      "text_es": data.text_es,
      "text_en": data.text_en,
      "desc_es": "",
      "title_es": "",
      "desc_en": "",
      "id_advertisement": data.id_advertisement,
      "title_en": "",
      "type": "banner"
    });
    setAdvertisementText(data.text_es);
    setAdvertisementTextEn(data.text_en);
  }

  const createStation = async (data) => {
    if(editQuillCreate) {
      Swal.fire("Nota", "por favor guarda el anuncio en español para continuar.", "warning")
      return;
    }

    if(editQuillCreateEn) {
      Swal.fire("Nota", "por favor guarda el anuncio en ingles para continuar.", "warning")
      return;
    }

    const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement/create`;
    const body = {
    "text_es": advertisementText,
    "text_en": advertisementTextEn,
    "desc_es": "",
    "title_es": "",
    "desc_en": "",
    "id_advertisement": "",
    "title_en": "",
    "type": "banner"
  }

    try {

      const response = await axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

      Swal.fire("¡Creado!", "creado exitosamente.", "success");
      setUpdateTrigger(!updateTrigger);
      statusModal();
      
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  }

  const updateStation = async (data) => {
    if(editQuillCreate) {
      Swal.fire("Nota", "por favor guarda el anuncio en español para continuar.", "warning")
      return;
    }

    if(editQuillCreateEn) {
      Swal.fire("Nota", "por favor guarda el anuncio en ingles para continuar.", "warning")
      return;
    }

    const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement/update/${data.id_advertisement}`;

    try {
      data.text_es = advertisementText;
      data.text_en = advertisementTextEn;
      
      const respose = await axios.put(url, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      });

      Swal.fire("¡Exitoso!", "Editado exitosamente.", "success");
      setUpdateTrigger(!updateTrigger);
      statusModal();
      
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al editar el anuncio",
        text: "No se ha editado ningún anuncio."
      });
      statusModal();
    }
  }

  const deleteAdvertisement = async (code) => {
    const url = `${process.env.REACT_APP_URL_BACKEND}/api/advertisement/${code}`;
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "esta estacion sera eliminada",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if(result.isConfirmed) {
        await axios.delete(url, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          }
        });
  
        Swal.fire("¡Eliminado!", "Eliminado Exitosamente.", "success");
      }
      setUpdateTrigger(!updateTrigger);
      
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error al eliminar el anuncio",
        text: "No se ha eliminado ningún anuncio."
      });
      statusModal();
    }
  }

  const quillDataAdvertisement = (data) => {
    setAdvertisementText(data);
    setEditQuillCreate(false);
  }

  const quillDataAdvertisementEn = (data) => {
    setAdvertisementTextEn(data);
    setEditQuillCreateEn(false);
  }

  return (
    <>
      <div className="headbands-container">

        <div className="btn-create-content-adv">
          {advertisement.length <= 1 && (
            <button className="btnn" onClick={() => statusModal('create')}>
              Crear Anuncio
            </button>
          )
          }
        </div>

        <div className="headbands-headers">
          <p className="title">Banner</p>
          <p className="actions">Acciones</p>
        </div>

        {advertisement.map((item, index) => (
          <div className="headbands-item">
            <p>{`banner ${index + 1}`}</p>
            <div className="btns-content">
              <button className="edit-btn" onClick={() => {
                setterCurrentAdvertisement(item);
                statusModal('update', item.id_advertisement);
              }}>
                <FaEdit />
              </button>
              <button className="delete-btn" onClick={() => deleteAdvertisement(item.id_advertisement)}>
                <FaTimes />
              </button>
            </div>
          </div>
        ))}

      </div>

      {/* =====================================================
      CREATE Modal
      ===================================================== */}
      {
        createModal && (
          <div className="station-modal">
            <div className="bg-modal-station" onClick={statusModal}></div>

            <section>
              <div className="header-station">
                <div></div>
                <h4>Crear Anuncio</h4>
                <div className="close-modal" onClick={statusModal} style={{fontSize: "1.5rem", cursor: "pointer"}}>
                  <FaXmark />
                </div>
              </div>

              <div className="body-station">
                  <form onSubmit={handleSubmit(createStation)}>
                    <h4 className="lng-text">Español</h4>

                    <div className="input-container-stations">
                      {editQuillCreate ? 
                        <CreateQuillComponent text={JSON.parse(advertisementText)} onQuillData={quillDataAdvertisement} title={"anuncio"} />
                      : 
                        <div style={{display: "flex", flexDirection:"column"}}>
                          <label>Horario:</label>
                          <ViewQuillComponent content={JSON.parse(advertisementText)} type={"json"} />
                          <button type="button" onClick={() => {setEditQuillCreate(true)}}>Editar Horario</button>
                        </div>
                      }
                    </div>

                    <h4 className="lng-text">Ingles</h4>

                    <div className="input-container-stations">
                      {editQuillCreateEn ? 
                        <CreateQuillComponent text={JSON.parse(advertisementTextEn)} onQuillData={quillDataAdvertisementEn} title={"anuncio"} />
                      : 
                        <div style={{display: "flex", flexDirection:"column"}}>
                          <label>Horario:</label>
                          <ViewQuillComponent content={JSON.parse(advertisementTextEn)} type={"json"} />
                          <button type="button" onClick={() => {setEditQuillCreateEn(true)}}>Editar Horario</button>
                        </div>
                      }
                    </div>
                    
                    <div className="btn-container-stations">
                      <button type="submit">Enviar</button>
                      <button type="button" className="closeModal" onClick={statusModal}>Cerrar</button>
                    </div>

                  </form>
              </div>
            </section>
          </div>
        )
      }

      {/* =====================================================
      UPDATE Station Modal
      ===================================================== */}
      {updateModal && (
        <div className="station-modal">
          <div className="bg-modal-station" onClick={statusModal}></div>

          <section>
            <div className="header-station">
              <div></div>
              <h4>Editar Anuncio</h4>
              <div className="close-modal" onClick={statusModal} style={{fontSize: "1.5rem", cursor: "pointer"}}>
                <FaXmark />
              </div>
            </div>

            <div className="body-station">
                <form onSubmit={handleSubmit(updateStation)}>
                  <h4 className="lng-text">Español</h4>

                  <div className="input-container-stations">
                    {editQuillCreate ? 
                      <CreateQuillComponent text={JSON.parse(advertisementText)} onQuillData={quillDataAdvertisement} title={"anuncio"} />
                    : 
                      <div style={{display: "flex", flexDirection:"column"}}>
                        <label>Horario:</label>
                        <ViewQuillComponent content={JSON.parse(advertisementText)} type={"json"} />
                        <button type="button" onClick={() => {setEditQuillCreate(true)}}>Editar Banner</button>
                      </div>
                    }
                  </div>

                  <h4 className="lng-text">Ingles</h4>

                  <div className="input-container-stations">
                    {editQuillCreateEn ? 
                      <CreateQuillComponent text={JSON.parse(advertisementTextEn)} onQuillData={quillDataAdvertisementEn} title={"anuncio"} />
                    : 
                      <div style={{display: "flex", flexDirection:"column"}}>
                        <label>Horario:</label>
                        <ViewQuillComponent content={JSON.parse(advertisementTextEn)} type={"json"} />
                        <button type="button" onClick={() => {setEditQuillCreateEn(true)}}>Editar Horario</button>
                      </div>
                    }
                  </div>
                  
                  <div className="btn-container-stations">
                    <button type="submit">Enviar</button>
                    <button type="button" className="closeModal" onClick={statusModal}>Cerrar</button>
                  </div>

                </form>
            </div>
          </section>
        </div>
      )}
    </>
  )
}

export default Advertisements;